import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import styled from './index.module.scss';

export default function Comp() {
    const dataA: EcoBannerProps = {
        layout: 'top-center',
        theme: 'black',
        heightType: 'full-screen',
        // isVideo: true,
        pc: 'https://websiteoss.ecoflow.com/upload/image/1755761700095/KV%20(1).jpg',
        pad: 'https://websiteoss.ecoflow.com/figma-uploads/1755742323879-hr2wut-compressed-D2M%20%E8%BD%A6%E4%B8%AD%E6%B3%8A.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1755760651925/m.jpg',
        label: <span className="label">大容量 × 高出力</span>,
        labelColor: '#fff',
        title: '快適も安心もクルマのなかに',
        subTitle: 'EcoFlow DELTA 2 Max ポータブル電源',
        subTitleColor: '#fff',
        titleColor: '#fff',
    };
    return (
        <div id="banner" className={`${styled.banner} GtmModuleData-section`} data-section-id={styled.banner} data-section-title={'快適も安心もクルマのなかに'}>
            <EcoBanner theme="black" {...dataA} />
        </div>
    );
}
